export default "__VITE_ASSET__45810734__"